import { render, staticRenderFns } from "./EmptyStateNotification.vue?vue&type=template&id=4b5a2c6e&"
import script from "./EmptyStateNotification.vue?vue&type=script&lang=js&"
export * from "./EmptyStateNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports